<template>
    <div class="header">

        <!-- 点击进入首页 -->
        <!-- <img class="logo" src="../../assets/images/Leica.png" width="25px" /> -->
        <span class="company">{{$t('message.title')}}</span>
        <el-dropdown @command="handleCommand">
            <!--绑定指令,在methods里定义-->
            <span class="el-dropdown-link">
                {{showLoginName}}
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <!-- icon是修改图标 ，command是点击后传给方法的值-->
                <el-dropdown-item icon="el-icon-edit" command="edit">{{$t('message.editpassword')}}</el-dropdown-item>
                <el-dropdown-item icon="el-icon-s-operation" command="quit">{{$t('message.logout')}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <!--修改密码-->
        <el-dialog :title="$t('message.editpassword')" :close-on-click-modal="false" :class="setRightDialogVisible?'animate__animated animate__bounceInLeft':'animate__animated animate__bounceOutRight'" :visible.sync="setRightDialogVisible" width="35%" @close="showSetRightDialogClosed">
            <!--内容主体区域-->
                <el-form :model="resetForm" :rules="resetFormRules" ref="resetForm" status-icon label-width="auto">
                    <el-form-item :label="$t('message.oldpassword')+':'" prop="OldPassWord">
                        <el-input type="password" v-model="resetForm.OldPassWord" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.newpassword')+':'" prop="PassWord">
                        <el-input type="password" v-model="resetForm.PassWord" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.confirmpassword')+':'" prop="CheckPassWord">
                        <el-input type="password" v-model="resetForm.CheckPassWord" auto-complete="off"></el-input>
                    </el-form-item>

                </el-form>
            <!--底部按钮区域-->
            <span slot="footer" class="dialog-footer">
                <el-button @click="setRightDialogVisible = false">{{this.$t('message.cancel')}}</el-button>
                <el-button type="primary" @click="EditPassWord">{{this.$t('message.determine')}}</el-button>
            </span>
        </el-dialog>
    </div>

</template>
<script>
var userId = window.sessionStorage.getItem("loginName");
let Base64 = require("js-base64").Base64;
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t("message.Pleaseenteranewpassword")));
            } else if (
                value.toString().length < 6 ||
                value.toString().length > 18
            ) {
                callback(new Error(this.$t("message.Passwordlength")));
            } else {
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(
                    new Error(this.$t("message.Pleaseenterthepasswordagain"))
                );
            } else if (value !== this.resetForm.PassWord) {
                callback(new Error(this.$t("message.Inconsistentpasswords")));
            } else {
                callback();
            }
        };
        return {
            setRightDialogVisible: false,
            resetForm: {
                OldPassWord: "",
                PassWord: "",
                CheckPassWord: "",
            },
            resetFormRules: {
                OldPassWord: [
                    {
                        required: true,
                        message: this.$t("message.Pleaseenteryouroldpassword"),
                        trigger: "blur",
                    },
                ],
                PassWord: [
                    {
                        required: true,
                        validator: validatePass,
                        trigger: "blur",
                    },
                ],
                CheckPassWord: [
                    {
                        required: true,
                        validator: validatePass2,
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    computed: {
        showLoginName() {
            return window.sessionStorage.getItem("loginName");
        },
    },
    methods: {
        showSetRightDialogClosed() {
            this.resetForm.OldPassWord = "";
            this.resetForm.PassWord = "";
            this.resetForm.CheckPassWord = "";
        },
        handleCommand(command) {
            if (command == "quit") {
                // 清空token
                window.sessionStorage.clear("token");
                this.$router.push("/Login");
                this.$message.success("退出成功");
            } else if (command == "edit") {
                this.setRightDialogVisible = true;
            }
        },
        async EditPassWord() {
            if (
                this.resetForm.CheckPassWord == "" ||
                this.resetForm.CheckPassWord == null
            ) {
                return this.$message.error("请输入确认密码");
            }
            var params = new URLSearchParams();
            params.append(
                "OldPassWord",
                Base64.encode(this.resetForm.OldPassWord)
            );
            params.append(
                "NewPassWord",
                Base64.encode(this.resetForm.PassWord)
            );
            this.$http
                .get(this.baseurl.baseURL + "/Api/User/EditPassWord", {
                    params,
                })
                .then((res) => {
                    if (res.data.Code == 200) {
                        console.log(res.data);
                        this.setRightDialogVisible = false;
                        var mes = res.data.Msg;
                        if (this.$i18n.locale == "en") {
                            mes = res.data.EnMsg;
                        }
                        this.$message.success(mes);
                        return this.$router.push("/Login");
                    } else if (res.data.Code == 401) {
                        this.$router.push("/Login");
                    } else {
                        return this.$message.error(res.data.Msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style scoped>
/* logo */
.logo {
    vertical-align: middle; /* 居中 */
    padding: 0px 10px 0px 40px; /* 上右下左 */
}

/* 文字 */
.company {
    position: absolute;
    color: white;
    margin-left: 20px;
}
.header {
    font-size: 13pt;
}
/* 下拉菜单 */
.el-dropdown {
    float: right; /* 浮动在右边 */
    margin-right: 40px; /* 靠右40px */
}
/* 系统管理 */
.el-dropdown-link {
    color: white;
    cursor: pointer; /* 鼠标放上去是手的形状 */
}
</style>


// WEBPACK FOOTER //
// src/components/AppHeader/index.vue